﻿import React from 'react';

//lib
import { motion, AnimatePresence } from "framer-motion";
import { v4 as uuidv4 } from 'uuid';

// utils
import IconHelper from '@bazooka_se/lf-icons';

// components
import PossessionsTabs from './PossessionsTabs';

const PossessionsAccordionItem = ({ id, combined, expanded, setExpanded, ind }) => {

    const [meta, setMeta] = React.useState([]);
    const [clauses, setClauses] = React.useState([]);
    const [noMeta, setNoMeta] = React.useState(false);
   
    // check if meta is an empty or undefined array or in fact has some data, in order to render correct DOM. A bit of a hack to account for some dicey data.
    React.useEffect(() => {

        if (combined.metaData) {

            if (combined.metaData.length > 0) {
                setMeta(combined.metaData[0]);
                setNoMeta(false)

            } else if (!combined.metaData.length || combined.metaData.contains(undefined)) {
                setNoMeta(true);
            }
        } 
    }, [combined.metaData]);


    React.useEffect(() => {

        if (combined.clauses !== null) {
            setClauses(combined.clauses);
        }
    }, [combined.clauses])

    const handleDataEvent = () => {
        dataLayer.push({
            'insurance_name': `${combined.productDisplayName}`,
            'event': 'possessions accordion opened'
        });
    }

  
    const isOpen = ind === expanded;

   
    const hasMetaData = meta.damageClaimInfo !== null || meta.insuranceCoverageInfo !== null || meta.terminateInsuranceInfo !== null;
    console.log("combined", combined)
    return (
        <li key={id} className={`possessions-accordion block-spacing ${isOpen ? "possessions-accordion--expanded" : ""}`}>
            <motion.header
                className="possessions-accordion__header"
                onClick={() => setExpanded(isOpen ? false : ind)}>

                <div className="possessions-accordion__top-section">

                    <h3 className="possessions-accordion__top-section__title">{combined.productDisplayName}</h3>

                    <p className="possessions-accordion__top-section__periodlabel">{combined.premiumPeriodLabel}:
                        <span className={`possessions-accordion__top-section__amount ${(noMeta === false && hasMetaData) ? "possessions-accordion__top-section__amount--divider" : ""}`}>
                            {combined.premium} kr
                            {(combined.ordinaryPremium !== null || combined.isOffer === true) &&
                            <span>*</span>
                            }
                        </span>

                        {(noMeta === false && hasMetaData) ?
                            <button
                                onClick={handleDataEvent}
                                className="possessions-accordion__top-section__icon"
                                dangerouslySetInnerHTML={{ __html: IconHelper('chev-down').outerHTML }}>
                            </button>
                            : null
                        }
                    </p>
                </div>

                {combined.insuranceObjectDisplayName !== null &&
                    <p className="possessions-accordion__policyholder" data-matomo-mask>Försäkringen gäller: {combined.insuranceObjectDisplayName}</p>
                }

                {(combined.fromDate !== null || combined.toDate !== null || combined.ordinaryPremium !== null || combined.ordinaryPremiumFromDate !== null || combined.clauses !== null) &&
                    <div className="possessions-accordion__duration">
                        <div className={`possessions-accordion__duration__dates ${combined.clauses ? "possessions-accordion__duration__dates--divider" : ""}`}>
                            <div className="possessions-accordion__duration__dates__container">
                                <p className="possessions-accordion__duration__dates__container__from"><span className="bold">Gäller från:</span> <span>{combined.fromDate}</span></p>
                                <p className="possessions-accordion__duration__dates__container__to"><span className="bold">Gäller till:</span> <span>{combined.toDate}</span></p>
                            </div>

                            {(combined.ordinaryPremium !== null || combined.ordinaryPremiumFromDate !== null) &&
                                <div className="possessions-accordion__duration__ordinary">
                                    <p className="possessions-accordion__duration__ordinary__text"><span className="bold">Ordinarie pris:</span> <span>{combined.ordinaryPremium} kr</span></p>
                                    <p className="possessions-accordion__duration__ordinary__from"><span className="bold">Ordinarie pris gäller från:</span> <span>{combined.ordinaryPremiumFromDate}</span></p>
                                </div>
                            }
                        </div>

                    {clauses && clauses.length > 0 && <h3 className="possessions-accordion__duration__clauses__title">Klausuler</h3>}
                       
                        <div className="possessions-accordion__duration__clauses">
                            {clauses && clauses.length > 0 && Object.keys(clauses).map((key, index) => (
                                <div className="possessions-accordion__duration__clauses" key={index}>
                                    <p className="possessions-accordion__duration__clauses__date"><span>Från:</span> {clauses[key].fromDate}</p>
                                    <p className="possessions-accordion__duration__clauses__text">{clauses[key].text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    }

                {(combined.ordinaryPremium !== null || combined.isOffer === true) &&
                    <p className="possessions-accordion__campaign"> *Försäkringen omfattas av ett erbjudande och du betalar inte ordinarie pris.</p>
                }
            </motion.header>

            <AnimatePresence
            initial={false}>

                {isOpen && hasMetaData && noMeta === false && (
                <motion.section
                    key="content"
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { opacity: 1, height: "auto" },
                        collapsed: { opacity: 0, height: 0 }
                    }}
                    transition={{ duration: 0.8 }}>

                    <PossessionsTabs
                        tabData={meta}
                        insuranceName={combined.productName}
                        key={uuidv4()}
                    />
            
                    <a className="arrow-link" href={meta.insurancePageLinkUrl}>
                        Läs mer om försäkringen och dess fullständiga villkor
                        <span dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}></span>
                    </a>

                </motion.section>
                )}
            </AnimatePresence>
                
            <div>
                {combined.canAddCoInsured === true &&
                    <div className="possessions-accordion__info-container">

                        <div className="possessions-accordion__info-container__icon-and-text">
                            <span
                                className="possessions-accordion__info-container__icon-and-text__icon"
                                dangerouslySetInnerHTML={{ __html: IconHelper('info-circle').outerHTML }}>
                            </span>
                            <p className="possessions-accordion__info-container__icon-and-text__text">Du kan lägga till en medförsäkrad</p>
                        </div>

                        <a className="possessions-accordion__info-container__button" href={meta.purchaseCoInsuredLinkUrl} id="add-coinsured">
                            Lägg till medförsäkrad
                        </a>
                    </div>
                    }

                {combined.canUpgrade === true &&
                    <div className="possessions-accordion__info-container">

                        <div className="possessions-accordion__info-container__icon-and-text">
                            <span className="possessions-accordion__info-container__icon-and-text__icon" dangerouslySetInnerHTML={{ __html: IconHelper('info-circle').outerHTML }}>
                            </span>
                            <p className="possessions-accordion__info-container__icon-and-text__text">Du kan uppgradera din försäkring</p>
                        </div>

                        <a className="possessions-accordion__info-container__button" href={meta.upgradeLinkUrl} >
                            {combined.upgradeOfferText}
                        </a>
                    </div>
                }
            </div>
        </li>
  )
}

export default PossessionsAccordionItem;
